import { Separator } from "@/components/ui/separator";
import { LuUser } from "react-icons/lu";
import { Link } from "react-router-dom";

type User = {
  cli_fantasia: string;
};

export function ProfileMenu({
  user,
  open,
  onToggle,
  onSignOut,
  onClose,
}: {
  user: User;
  open: boolean;
  onToggle: () => void;
  onSignOut: () => void;
  onClose: () => void;
}) {
  return (
    <div className="relative hidden lg:block">
      <button
        className="flex h-12 w-12 items-center justify-center rounded-full text-n-text-light hover:opacity-90"
        onClick={onToggle}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <LuUser className="h-6 w-6" />
        <span className="sr-only">Abrir menu do perfil</span>
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 w-56 rounded-md border bg-white z-50 p-2 shadow-md"
          role="menu"
          aria-label="Menu do perfil"
        >
          <div className="px-2 pb-2 pt-1">
            <p className="text-sm text-n-text-neutral">Olá,</p>
            <p className="truncate font-semibold text-n-text">
              {user.cli_fantasia}
            </p>
          </div>
          <Separator />
          <Link
            to="/cliente"
            className="block rounded-md px-3 py-2 text-sm hover:bg-n-green-h-light hover:text-n-text-green"
            role="menuitem"
            onClick={onClose}
          >
            Área do Cliente
          </Link>
          <button
            className="w-full rounded-md px-3 py-2 text-left text-sm text-red-700 hover:bg-n-green-h-light"
            onClick={onSignOut}
            role="menuitem"
          >
            Sair
          </button>
        </div>
      )}
    </div>
  );
}
